import React, { useEffect, useRef, useState } from "react";
import { Share2, Link as LinkIcon, MessageCircle, Instagram, Check } from "lucide-react";
import { toast } from "sonner";

export function ShareButton({ title, text, url = typeof window !== "undefined" ? window.location.href : "" }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 2000); toast.success("Link copied"); }
    catch { toast.error("Could not copy link"); }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text, url }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    setOpen((v) => !v);
  };
  const wa = `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;
  const ig = async () => { await copy(); toast("Link copied — paste it into your Instagram story or bio"); window.open("https://www.instagram.com/", "_blank", "noopener"); };

  return (
    <div className="relative inline-block" ref={ref}>
      <button onClick={share} className="btn-secondary" data-testid="share-profile-btn"><Share2 size={14} /> Share profile</button>
      {open && (
        <div className="absolute z-40 mt-2 right-0 w-64 card-ive p-2 shadow-2xl" data-testid="share-menu">
          <a href={wa} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2.5 text-sm hover:bg-[#161616] transition-colors" data-testid="share-whatsapp">
            <MessageCircle size={16} className="text-[#25D366]" /> WhatsApp
          </a>
          <button onClick={ig} className="w-full flex items-center gap-3 px-3 py-2.5 text-sm hover:bg-[#161616] transition-colors text-left" data-testid="share-instagram">
            <Instagram size={16} className="text-[#E1306C]" /> Instagram <span className="type-meta text-[#666] ml-auto">copies link</span>
          </button>
          <button onClick={copy} className="w-full flex items-center gap-3 px-3 py-2.5 text-sm hover:bg-[#161616] transition-colors text-left" data-testid="share-copy">
            {copied ? <Check size={16} className="text-[#C8102E]" /> : <LinkIcon size={16} />} {copied ? "Copied" : "Copy link"}
          </button>
        </div>
      )}
    </div>
  );
}
